import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, FormGroup, Label, H2, Image, } from './Login.styles';
import './Login.css'
import apis from '../../api';
import authenticationService from '../../services/authentication.service';
import { useAuthentication } from "../../session/AuthenticationProvider";
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import TermsModal from '../TermsModal/TermsModal';
import Base64Downloader from 'common-base64-downloader-react';
import ReCAPTCHA from "react-google-recaptcha";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Login
Description : Pagina de inicio al ingresar al aplicativo remunerlite, pagina de 
              logueo.
Date Autor Modification
================================================================================
1/10/2021 Cristian Andres Pizo Mina - Pagina de Login
2/11/2021 Cristian Andres Pizo Mina – Se modifico logeo al paquete authenticationService.
05/4/2022 Cristian Andres Pizo Mina - Comentarios
================================================================================ */

export default function Login() {

    // Declarar variables de estado
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [mostrarSpiner, setMostrarSpiner] = useState(false);
    const [emailRestore, setEmailRestore] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [token, setToken] = useState("");
    const toast = useRef(null);
    const [isOpen, setIsOpen] = React.useState(false);
    const [isOpenToken, setIsOpenToken] = React.useState(false);
    const [isOpenPassword, setIsOpenPassword] = React.useState(false);
    const [isOpenTerms, setIsOpenTerms] = useState(false);
    const [loading, setLoading] = useState(false);
    const auth = useAuthentication();
    const [captcha, setCaptcha] = useState(false);
    const [attempts, setAttempts] = useState(0)

    const [fileTerms, setFileTerms] = useState("");
    const [filePolicies, setFilePolicies] = useState("");
    const [nameTerms, setNameTerms] = useState("");
    const [namePolicies, setNamePolicies] = useState("");

    const recaptchaRef = React.createRef()

    useEffect(() => {
        /*Se encarga de mostar el spinner de la vista si no se ha clickeado el botón*/
        const getTerms = async () => {
            await apis.postLegalTerms({}).then(res => {
                let doc1 = "data:application/pdf;base64," + res.data.PDF_POLICIES.DATA
                let doc2 = "data:application/pdf;base64," + res.data.PDF_TERMS.DATA
                setFileTerms(doc2)
                setFilePolicies(doc1)
                setNameTerms(res.data.PDF_TERMS.NAME)
                setNamePolicies(res.data.PDF_POLICIES.NAME)
            }).catch(err => {
                console.log(err)
            })
        }
        getTerms()
    }, []);

    useEffect(() => {
        if (attempts >= 3) {
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Sobrepasaste los intentos permitidos. Inténtalo nuevamente en 5 minutos', sticky: true });
            setTimeout(() => {
                setAttempts(0)
            }, 300000)
        }
    }, [attempts])

    // función que octiene el evento del formulario Loguin
    function handleSubmit(event) {
        event.preventDefault();
    }

    const showModalTerms = () => {
        setIsOpenTerms(true);
    }

    const hideModalTerms = () => {
        setIsOpenTerms(false);
    }

    // función que valida el formulario de logueo
    function validar() {
        if (email == "") {
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregar correo', life: 4000 })
            return false
        } if (password == "") {
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: "Agregar contraseña", life: 4000 });
            return false
        } if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: "Error en formato de correo", life: 4000 });
            return false
        }

        return true
    }

    // función limpiar formulario de recuperación de contraseña
    function limpiar() {
        setEmailRestore(null)
        setNewPassword(null)
        setConfirmPassword(null)
        setToken(null)
    }

    // función para loguearse
    const login = async () => {
        if (validar()) {
            setMostrarSpiner(true);
            authenticationService.signIn(email, password).then(user => {
                auth.login(user);
                const headers = {
                    authorization: localStorage.getItem('token')
                }

                apis.getUserType(headers).then(res => {
                    if (res.data.TYPE_USER === 'ADMIN') {
                        let terms = res.data.TERMS
                        if (terms === 'N') {
                            showModalTerms()
                        }
                        else {
                            redirectLogin()
                        }
                    }
                    else {
                        setLoading(false)
                        setMostrarSpiner(false);
                        toast.current.show({
                            severity: 'info', summary: 'Alerta', content: (props) => (
                                <div className="flex flex-column align-items-left" style={{ flex: '1' }}>
                                    <div className="flex align-items-center gap-2">
                                        <i className='pi pi-info-circle' style={{ color: 'var(--primary-color)' }} />
                                        <span style={{ color: 'var(--primary-color)' }} className="font-bold">Información</span>
                                    </div>
                                    <div className="text-md my-3" style={{ color: 'var(--primary-color)' }}>
                                        No es posible ingresar dado que eres un usuario de autogestión, para ingresar por favor ve a la URL:{" "}
                                        <a href='https://selfservice.remuner.com.co' className='font-bold' style={{
                                            textDecoration: 'underline', cursor: 'pointer',
                                            color: 'var(--primary-color)'
                                        }}>Autogestión Remuner</a>
                                    </div>
                                </div>
                            ), sticky: true
                        });
                    }
                })


                // apis.getBusiness(headers).then(res => {
                //     window.location.href = "./Home";
                //     localStorage.setItem('logo', res.data.COMPANY[0].LOGO)
                //     setMostrarSpiner(false);
                // }).catch(err => {
                //     if (localStorage.getItem("type") === "ADMIN") {
                //         if (localStorage.getItem("enabled") === "S") {
                //             window.location.href = "CompanyInfo";
                //         }
                //         if (localStorage.getItem("enabled") === "N") {
                //             console.log("sssssssss")
                //             window.location.href = "Verification";
                //         }
                //     }
                //     else {
                //         if (localStorage.getItem("type") === "CLIENT") {
                //             window.location.href = "Certificate";
                //         }
                //     }
                //     setMostrarSpiner(false);
                // })

            })
                .catch(err => {
                    let msg = err === 401 ? 'Usuario y/o contraseña incorrectos' : 'No se pudo iniciar sesión'
                    toast.current.show({ severity: 'warn', summary: 'Alerta', detail: msg });
                    setMostrarSpiner(false);
                    setAttempts(attempts + 1)
                })
        }
    }

    const acceptTermsAndPolicies = async () => {
        const headers = {
            authorization: localStorage.getItem('token')
        }
        try {
            await apis.acceptTerms({}, headers).then(res => {
                console.log('accepted')
                redirectLogin()
            })
        }
        catch (err) {
            cancelAction()
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: "No se pudo iniciar sesion" });
        }
    }

    const redirectLogin = async () => {
        setLoading(true)
        const headers = {
            authorization: localStorage.getItem('token')
        }

        apis.getBusiness(localStorage.getItem('token'), headers).then(res => {
            window.location.href = "./Home";
            localStorage.setItem('logo', res.data.COMPANY[0].IMAGES)
            setMostrarSpiner(false);
            setLoading(false)
        }).catch(err => {
            if (localStorage.getItem("type") === "ADMIN") {
                if (localStorage.getItem("enabled") === "S") {
                    window.location.href = "Home";
                }
                if (localStorage.getItem("enabled") === "N") {
                    console.log("sssssssss")
                    window.location.href = "Verification";
                }
            }
            else {
                if (localStorage.getItem("type") === "CLIENT") {
                    window.location.href = "Certificate";
                }
            }
            setMostrarSpiner(false);
            setLoading(false);
        })
    }

    const cancelAction = async () => {
        authenticationService.signOut();
        auth.logout();
        hideModalTerms();
    }

    // función para validar si es un correo valido
    function validarCorreo(correo) {

        if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(correo)) {
            return true;
        }
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: "Error en formato de correo", life: 4000 });
        return false;
    }

    // función para recuperar contraseña
    const recuperar = () => {
        if (validarCorreo(emailRestore)) {
            const _email = emailRestore;
            const email = {
                EMAIL: _email
            }
            apis.postSendEmail(email).then(res => {
                setIsOpen(false);
                setIsOpenToken(true);
                toast.current.show({ severity: 'success', summary: 'Se envio el token a su correo', detail: 'Por favor revise su bandeja de correo o span', life: 8000 });
            }).catch(err => {
                toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
            })

        }
    }

    // función para validar token
    const verificateToken = () => {
        setIsOpenToken(false);
        setIsOpenPassword(true);
    }

    // función para validar contraseña
    const restarPassword = () => {
        if (compararPassword()) {
            const _email = emailRestore;
            const _token = token;
            const _newPassword = newPassword;
            const _confirmPassword = confirmPassword;
            const datos = {
                EMAIL: _email,
                PASSNW: _newPassword,
                PASSNW_CONF: _confirmPassword,
                TOKEN: _token
            }
            apis.postUpdatePassword(datos).then(res => {
                limpiar()
                setIsOpenPassword(false);
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Contraseña actualizada existosamente. Inicie sesión por favor." });

                // authenticationService.signIn(emailRestore, confirmPassword).then(user => {
                //     auth.login(user);

                //     const headers = {
                //         authorization: localStorage.getItem('token')
                //     }

                //     apis.getBusiness(headers).then(res => {
                //         window.location.href = "./Home";
                //         setMostrarSpiner(false);
                //     }).catch(err => {
                //         window.location.href = "CompanyInfo";
                //     })


                // })
                //     .catch(err => {
                //         toast.current.show({ severity: 'warn', summary: 'Alerta', detail: "No se pudo iniciar sesion" });
                //         setMostrarSpiner(false);
                //     })

            }).catch(err => {
                toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
            })
        }
    }

    // función para comparar contraseñas
    function compararPassword() {
        if (newPassword != confirmPassword) {
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Las contraseñas no conciden', life: 4000 })
            return false
        }
        return true
    }

    // cerrar modal
    const hideModal = () => {
        setIsOpen(false);
    };

    // abrir modal
    const showModal = () => {
        setIsOpen(true);
    };

    // pie de pagina para modal de recuperar contraseña
    const footer = (
        <div>
            <Button className="p-button-sm p-button-secondary" onClick={hideModal}>Cancelar</Button>
            <Button className="p-button-sm" onClick={recuperar} disabled={emailRestore == null || emailRestore == ''}>Enviar</Button>
        </div>
    );

    // encabezado de modal para recuperar contraseña
    const header = (
        <div>
            <p>Ingrese tu correo</p>
        </div>
    );

    // cerrar modal de token
    const hideModalToken = () => {
        setIsOpenToken(false);
    };


    // pie de pagina para modal de token
    const footerToken = (
        <div>
            <Button className="p-button-sm p-button-secondary" onClick={hideModalToken}>Cancelar</Button>
            <Button className="p-button-sm" onClick={verificateToken} disabled={token == null || token == ''}>Continuar</Button>
        </div>
    );

    // encabezado de modal para token
    const headerToken = (
        <div>
            <p>Ingrese su Token</p>
        </div>
    );

    // cerrar modal de contraseña y limpiar campos
    const hideModalPassword = () => {
        limpiar()
        setIsOpenPassword(false);
    };

    // pie de pagina para modal de contraseña
    const footerPassword = (
        <div>
            <Button className="p-button-sm p-button-secondary" onClick={hideModalPassword}>Cancelar</Button>
            <Button className="p-button-sm" onClick={restarPassword} disabled={newPassword == null || newPassword == '' || confirmPassword == null || confirmPassword == ''}>Continuar</Button>
        </div>
    );

    // encabezado de modal para contraseña
    const headerPassword = (
        <div>
            <p>Ingrese su nueva contraseña</p>
        </div>
    );

    // constantes para el cuerpo de parametros minimo de contraseña
    const passwordHeader = <h6>Su contraseña es:</h6>;
    const passwordFooter = (
        <React.Fragment>
            <Divider />
            <p className="mt-2">Sugerencias</p>
            <ul className="pl-2 ml-2 mt-0" style={{ lineHeight: '1.5' }}>
                <li>Al menos una mayúscula</li>
                <li>Al menos un número</li>
                <li>Al menos un caracter especial</li>
                <li>Mínimo 8 caracteres</li>
            </ul>
        </React.Fragment>
    );

    const onChange = async () => {
        const recaptchaValue = recaptchaRef.current.getValue();
        let payload = {
            response: recaptchaValue
        }
        try {
            await apis.postCaptcha(payload).then(res => {
                const resp = res.data.success
                if (resp) {
                    setCaptcha(resp)
                }
                else {
                    setCaptcha(resp)
                    recaptchaRef.current.reset();
                }
            })
        }
        catch (err) {
            console.log(process.env.REACT_APP_ENV)
            if (process.env.REACT_APP_ENV === 'local') {
                setCaptcha(true)
            }
            else {
                setCaptcha(false)
                recaptchaRef.current.reset();
            }
        }
    }

    // Return que entrega la pantalla
    return (
        <Form className='form' onSubmit={handleSubmit}>
            <Toast ref={toast} />
            <TermsModal
                accept={acceptTermsAndPolicies}
                cancel={cancelAction}
                isOpenTerms={isOpenTerms}
                setIsOpenTerms={setIsOpenTerms}
                loading={loading}
                setLoading={setLoading}
            />
            <Dialog header={header} footer={footer} visible={isOpen} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
                <span className="p-float-label">
                    <InputText style={{ width: "100%" }} id="inputgroup" type="email" value={emailRestore} onChange={(e) => setEmailRestore(e.target.value)} />
                    <label htmlFor="inputgroup">Correo</label>
                </span>
            </Dialog>
            <Dialog header={headerToken} footer={footerToken} visible={isOpenToken} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalToken}>
                <span className="p-float-label">
                    <InputText style={{ width: "100%" }} id="inputgroup" type="text" value={token} onChange={(e) => setToken(e.target.value)} />
                    <label htmlFor="inputgroup">Token</label>
                </span>
            </Dialog>
            <Dialog header={headerPassword} footer={footerPassword} visible={isOpenPassword} position="top" style={{ width: "24rem" }} draggable={false} resizable={false} modal onHide={hideModalPassword}>
                <span className="p-float-label">

                    <Password id="password" name="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
                        toggleMask header={passwordHeader} footer={passwordFooter}
                        mediumRegex={"^(((?=.*[!@#$&()\\-`.+,/\"])(?=.*[A-Z]))|((?=.*[!@#$&()\\-`.+,/\"])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})."}
                        strongRegex={"^(?=.*[!@#$&()\\-`.+,/\"])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"}
                        weakLabel="Débil" mediumLabel="Media" strongLabel="Fuerte" promptLabel="Digite su contraseña" />
                    <label htmlFor="inputgroup">Nueva contraseña</label>
                </span>
                <span className="p-float-label mt-5">
                    <Password value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} toggleMask feedback={false} />
                    <label htmlFor="inputgroup">Confirme contraseña</label>
                </span>
            </Dialog>
            <H2 style={{ marginTop: "-2rem", marginBottom: "4rem" }}>
                <Image
                    src={process.env.REACT_APP_LOGO_LOGIN}
                    alt="MiRemuner"
                    style={{ width: "20rem", height: "20rem" }}
                />
            </H2>
            <FormGroup
                style={{ marginTop: "-4rem" }}
            >
                {/* <LabelField htmlFor="label">Correo</LabelField> */}
                {/* <InputText id="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)}/> */}
                {/* <Input 
                id="label1"
                autoFocus 
                type="email" 
                value={email}
                placeholder="Ingrese su correo"
                onChange={(e) => setEmail(e.target.value)}
                /> */}

                <div className="p-inputgroup">
                    <span className="p-inputgroup-addon">
                        <i className="pi pi-user"></i>
                    </span>
                    <span className="p-float-label">
                        <InputText id="inputgroup" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                        <label htmlFor="inputgroup">Correo</label>
                    </span>
                </div>

            </FormGroup>



            <FormGroup>


                <div className="p-inputgroup" style={{ width: '18rem' }}>
                    <span className="p-inputgroup-addon">
                        <i className="pi pi-lock"></i>
                    </span>
                    <span className="p-float-label">
                        <Password value={password} inputStyle={{ width: '15.8rem' }} onChange={(e) => setPassword(e.target.value)} toggleMask feedback={false} />
                        <label htmlFor="inputgroup">Contraseña</label>
                    </span>
                </div>
            </FormGroup>
            <div>
                <a onClick={showModal} style={{ cursor: 'pointer', color: '#3498DB' }}>¿No recuerdas tu contraseña?</a>
            </div>
            {mostrarSpiner && <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-100	)" animationDuration=".5s" />}
            {captcha === false && email && password &&
                <ReCAPTCHA
                    ref={recaptchaRef}
                    className='captcha'
                    sitekey={process.env.REACT_APP_CAPTCHA_KEY}
                    onChange={onChange}
                />}
            {mostrarSpiner == false && captcha === true && <Button className='m-2' block type="submit" onClick={login} disabled={attempts >= 3}>
                Iniciar sesion
            </Button>}
            <Label htmlFor="label">
                ¿Aun no tienes cuenta?
                {' '}
                <Link to="/Register" style={{ color: 'blue', textDecoration: 'underline' }}>Regístrate</Link>
            </Label>
            <p className='mt-2 text-xs text-600 line-height-1'>
                Al hacer clic en Iniciar sesión, estas aceptando nuestros
                <Base64Downloader style={{ textDecoration: "underline", textDecorationColor: "blue", color: "blue", background: "transparent", border: "0px" }} base64={fileTerms} downloadName={nameTerms}>
                    Términos y condiciones de servicio,
                </Base64Downloader>
                y estas aceptando nuestra
                <Base64Downloader style={{ textDecoration: "underline", textDecorationColor: "blue", color: "blue", background: "transparent", border: "0px" }} base64={filePolicies} downloadName={namePolicies}>
                    Política de privacidad de datos.
                </Base64Downloader>
            </p>
            <p className='mt-2 text-sm font-bold text-600 line-height-1'>
                Si eres un usuario de autogestión o selfservices, ingresa a esta URL:
                {' '}
                <a href="https://selfservice.remuner.com.co" style={{ color: 'blue', textDecoration: 'underline' }}>Autogestión Remuner</a>
            </p>
        </Form>
    );
}